/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gc_Resources_Compare_License_ExcelInputs */

const en_gc_resources_compare_license_excel = /** @type {(inputs: Gc_Resources_Compare_License_ExcelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Proprietary`)
};

const zh_gc_resources_compare_license_excel = /** @type {(inputs: Gc_Resources_Compare_License_ExcelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`专有软件`)
};

/**
* | output |
* | --- |
* | "Proprietary" |
*
* @param {Gc_Resources_Compare_License_ExcelInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const gc_resources_compare_license_excel = /** @type {((inputs?: Gc_Resources_Compare_License_ExcelInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gc_Resources_Compare_License_ExcelInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_gc_resources_compare_license_excel(inputs)
	return zh_gc_resources_compare_license_excel(inputs)
});
export { gc_resources_compare_license_excel as "gc.resources.compare.license.excel" }